import type {
  Task,
  TaskFacets,
  TaskHubTab,
  TaskInput,
  TaskPriority,
  TaskSortField,
  TaskStatus,
  TaskType,
} from "@sales-ops-amplify/shared";
import { apiGet, apiPatch, apiPost } from "./client";

export type ListTasksParams = {
  tab?: TaskHubTab;
  type?: TaskType;
  status?: TaskStatus | "open";
  priority?: TaskPriority;
  dueFrom?: string;
  dueTo?: string;
  sequenceId?: string;
  leadId?: string;
  opportunityId?: string;
  q?: string;
  sort?: TaskSortField;
  sortDir?: "asc" | "desc";
  limit?: number;
};

export function listTasks(
  params?: ListTasksParams,
): Promise<{ tasks: Task[]; facets: TaskFacets; total: number }> {
  return apiGet(
    "/api/tasks",
    params as Record<string, string | number | boolean | undefined>,
  );
}

export function getRecommendedTasks(
  limit = 50,
): Promise<{ tasks: Task[] }> {
  return apiGet("/api/tasks/recommended", { limit });
}

export function getTask(taskId: string): Promise<{ task: Task }> {
  return apiGet(`/api/tasks/${taskId}`);
}

export function createTask(input: TaskInput): Promise<{ task: Task }> {
  return apiPost("/api/tasks", input);
}

export function updateTask(
  taskId: string,
  patch: Partial<TaskInput> & { status?: TaskStatus; completed?: boolean },
): Promise<{ task: Task }> {
  return apiPatch(`/api/tasks/${taskId}`, patch);
}

export function completeTask(
  taskId: string,
  notes?: string,
): Promise<{ task: Task }> {
  return apiPost(`/api/tasks/${taskId}/complete`, { notes });
}

export function skipTask(taskId: string): Promise<{ task: Task }> {
  return apiPost(`/api/tasks/${taskId}/skip`, {});
}

export function bulkUpdateTasks(body: {
  taskIds: string[];
  action: "complete" | "reschedule" | "priority" | "skip";
  dueAt?: string;
  priority?: TaskPriority;
}): Promise<{ tasks: Task[]; updated: number }> {
  return apiPost("/api/tasks/bulk", body);
}
